<template>
  <div class="container-scroll-story" :ref="fUniqContainer">
      <div class="row justify-content-center">
        <div class="d-none d-md-block col-12 col-sm-7 col-md-6 col-lg-5 col-xl-5" v-if="cardText[0].position == `left`">
          <div class="image-side-container">
            <div class="frame-phone">
              <div class="phone-container">
                <div class="header"></div>
                <div class="screen" :ref="fUniq">
                    <div class="img-t-c"  v-for="(t, x) in cardImages" :key="x">
                      <ImageElement :class="`img-ix-${t.item_id}`" :imageData="imageDataScroll(t)" />
                    </div>
                </div>
                <div class="footer"></div>
              </div>
            </div>
          </div>
        </div>
      
        <div class="col-12 col-sm-10 col-md-6 col-lg-7 col-xl-6">
            <div class="storytelling">
              <div class="" v-for="(text, ix) in cardText" :key="ix">
                <div class="image-side-trigger" :class="`img-ix-${text.item_id} ${fUniq}`" v-if="text.imageBg">
                  <p v-html="text.text"></p>
                  <div class="d-block d-md-none p-3 p-sm-5">
                    <ImageElement :class="`img-ix-${text.item_id}`" :imageData="imageDataScroll(text)" />
                  </div>
                </div>
                <p v-if="!text.imageBg" v-html="text.text"></p>
              </div>              
            </div>
            
        </div>
      </div>    
  </div>
</template>

<style lang="scss">

  @keyframes slideUp {
    from {
      opacity: 0.7;
      margin-top: 35px;
    }

    to {
      opacity: 1;
      margin-top: 0;
    }
  }
  
  @keyframes slideCenter {
    from {
      transform: scale(0.8);
    }

    to {
      transform: scale(1);
    }
  }

  .image-side-container {
    position: sticky;
    top: 0;
  }

  .image-side-static {
    visibility: hidden;
    pointer-events: none;
    display: block;
  }

  .phone-container {
    width: 90%;
    height: 100%;
    min-height: 520px ;
    max-height: 710px ;
    top: calc(100% / 7.7);
    position: relative;
    padding: 0 0% 0 calc(100% / 9.5);
    overflow: hidden;
  }

  .frame-phone {
    position: relative;
    width: 100%;
    max-width: 420px;
    height: 100vh;
    min-height: 870px;
    margin: 0 auto;
    padding: 0 5% 0 7%;
    display: block;
    height: 100vh;
    background-image: url('../assets/frame.png');
    background-repeat: no-repeat;
    background-size: 112%;
    background-position: center 0;
    
    &.active {
      img {
        display: block;
        opacity: 1;
        transition: opacity .25s ease-in-out;
      }
    }
    
    img {
      width: 100%;
      opacity: 1;
    }

    .screen {
      width: 100%;
      max-width: 335px;
      margin: 0 auto;
      padding: 25px 0;
      padding-bottom: 45px;
      height: 73vh;
      min-height: 620px;
      overflow-y: hidden;
      position: relative;
      border-radius: 10px;

      .img-t-c {
        margin-top: 0;
        opacity: 1;
        animation-name: slideUp;
        animation-duration: 1.85s;
        border-bottom: solid 1px #e3e3e3;
      }

      img {
        padding: 15px 0;
        opacity: 0.7;
        transform: scale(0.7);

        &.active {
          opacity: 0.7;
          transition: opacity .65s ease-in-out;
        }

        &:hover {
          opacity: 1;
          transition: opacity .25s ease-in-out;
          cursor: pointer;
        }
        &.current {
          opacity: 1;
          transition: opacity .25s ease-in-out;
          opacity: 1;
          border: solid 2px #c85fe5;
          box-shadow: 0px 0px 12px 2px #fff600f0;
          z-index: 99;
          left: 0;
          transform: scale(0.9);
          animation-name: slideCenter;
          animation-duration: 0.25s;
        }
      }
    }
  }


  .ministerio-dv  {
    @media screen and (max-width: 767px){
      margin-top: 10px !important;
      padding-top: 0 !important;
    }
  }

  .agenda-propia {   
    padding-bottom: 120px;

    @media screen and (max-width: 767px){      
      padding-bottom: 55px !important;
    }
  }
</style>

<script>

import images from '@/mixins/images'

export default {
  name: 'ScrollCard',
  mixins: [images],
  props: {
    cardText: [Array, Object]
  },
  computed: {
    fUniqContainer() {
      return `container-${this._uid}`
    },
    fUniq() {
      return `frame-${this._uid}`
    },
    cardImages() {
      return this.cardText.filter( i => {
        if(i.imageBg){
          return i
        }
      })
    }
  },
  mounted() {
    
    // Set up Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let imgId = entry.target.classList[1]
          let frameId = entry.target.classList[2]
          let imgTweet = document.querySelector(`.${imgId}`)

          if(this.$refs[frameId]) {
            this.$refs[frameId].scrollTop = imgTweet.offsetTop - 55
          }

          imgTweet.classList.add('active')
          imgTweet.classList.add('current')
          entry.target.querySelector(`strong`).classList.add(`active`)
        } 
        else {
          let imgId = entry.target.classList[1]
          let imgTweet = document.querySelector(`.${imgId}`)
          imgTweet.classList.remove('current')

          if(entry.target.querySelector(`strong`)) {
            entry.target.querySelector(`strong`).classList.remove(`active`)
          }
        }
      });
    }, { threshold: 0.5 });
    
    // Observe all scroll sections
    this.$refs[this.fUniqContainer].querySelectorAll('.image-side-trigger').forEach(section => {
      observer.observe(section)
    });
  }
}
</script>
